import axios from './axios_config';

export const getDefaults = async () => {
    let result = await axios.get('/api/v1/users/defaults/user/');
    return result;
};

export const saveDefaults = async (data) => {
    let result = await axios.post('/api/v1/users/defaults/', data);
    return result;
};

export const changeDefaults = async (id, data) => {
    let result = await axios.patch(`/api/v1/users/defaults/${id}/`, data);
    return result;
};

export const deleteDefaults = async () => {
    let result = await axios.delete('/api/v1/users/defaults/6097/');
    return result;
};

export const getAccessToken = async (data) => {
    let result = await axios.post('/api/token/', data);
    return result;
};
